/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpGkeCluster extends models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpGkeCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpGkeCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpGkeCluster>): ServiceAccountNativeDetailsForGcpGkeCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpGkeCluster(), model);
        ServiceAccountNativeDetailsForGcpGkeCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpGkeCluster>): ServiceAccountNativeDetailsForGcpGkeCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpGkeCluster.newInstance(<ServiceAccountNativeDetailsForGcpGkeCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpGkeCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpGkeCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpGkeCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpGkeCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
